$(document).ready(function(){
  var owl = $('.gray-new-collection .product-list');
  // Carousel is infinite (loop:true in theme.js), so both arrows stay
  // visible/enabled at all times instead of being hidden at the ends.
  function hide_arrows(){
    $(".gray-new-collection .prev.ltr-icon, .gray-new-collection .next.ltr-icon").removeClass("hidden");
  }
  hide_arrows();
  owl.on('changed.owl.carousel', function(event) {
    setTimeout(function(){
      hide_arrows();
    }, 100);
  });
});